module.exports = __webpack_public_path__ + "static/x54-d9fdb069671fb5c55bd2e012ea2c0c27.png";